import { chance, random } from 'helpers';
import * as setup from 'setup';
import Food from '../Food/Food';
import Danger from './Danger';

export default class DangerAntWorker extends Danger {

    target?: Food | null;

    constructor(gameState: GameState, props?: DangerProps, state?: any) {
        super(gameState, 'antWorker',  setup.dangers.antWorker, props, state);

        // Initialize
        this.x = (props?.x || (random(-1, 1, true) + this.colony.cell.x)) * setup.map.cells.size;
        this.y = (props?.y || (random(-1, 1, true) + this.colony.cell.y)) * setup.map.cells.size;
        this.zIndex = 3;
    }

    init = () => {
        this.findFood();
    }

    findFood = () => {
        if (!this.target || chance(this.setup.retargetChance)) {
            // Get closest food
            this.target = this.getClosestTarget(this.gameState.entities.foods.active);
            this.targetEngaged = false;
        }

        // If close enough move to, otherwise wander towards
        if (this.target && (this.targetEngaged || this.isCloseToTarget(this.target, this.setup.searchDistance))) {
            this.moveTo(this.target.cell, this.target.size / 2 - 1, this.gatherFood);
        } else if (this.target) {
            this.wanderTo(this.target.cell, 0.5, this.findFood);
        } else {
            this.wanderTo(this.cell, 0, this.findFood);
        }
    }

    gatherFood = () => {
        this.queue(this.carryFood, true);
    }

    carryFood = () => {
        const carryAmount = (this.isCloseToTarget(this.target) && this.target?.subtractCalories(this.setup.carryCapacity || 0)) || 0;

        if (carryAmount) {
            this.targetEngaged = true;
            this.moveToTarget(this.colony, this.findFood);
        } else {
            this.wanderTo(this.cell, 0, this.findFood);
        }
    }

}